import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
  tooltip: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_c_icon_btn = _resolveComponent("c-icon-btn")!

  return (_openBlock(), _createBlock(_component_c_icon_btn, {
    "data-id": "context-menu-btn",
    icon: "mdi-dots-vertical",
    "tooltip-right": __props.tooltip || _ctx.$t('inri.common.more'),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, { class: "menu-list pb-0" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["tooltip-right"]))
}
}

})